var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EventEmitter } from "../eventEmitter";
import { HttpError } from "./httpError";
export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["HEAD"] = "HEAD";
    HttpMethod["TRACE"] = "TRACE";
    HttpMethod["OPTIONS"] = "OPTIONS";
    HttpMethod["CONNECT"] = "CONNECT";
})(HttpMethod || (HttpMethod = {}));
export var HttpClientEvent;
(function (HttpClientEvent) {
    HttpClientEvent["REQUEST_CREATE"] = "REQUEST_CREATE";
})(HttpClientEvent || (HttpClientEvent = {}));
const defaultConfig = {
    withEvents: true,
};
export class HttpClient {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.em = new EventEmitter();
    }
    static get REQUEST_CREATE() {
        return "REQUEST_CREATE";
    }
    static get RESPONSE_FETCHED() {
        return "RESPONSE_FETCHED";
    }
    static get RESPONSE_CREATE() {
        return "RESPONSE_CREATE";
    }
    createURL(url, config) {
        let baseUrl = this.baseUrl;
        try {
            new URL(url);
            baseUrl = "";
        }
        catch (err) {
            //it's a relative url
        }
        let query = "";
        if (config === null || config === void 0 ? void 0 : config.params) {
            let params = {};
            Object.entries(config.params).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    params[key] = value.toString();
                }
            });
            query = config ? "?" + new URLSearchParams(params).toString() : undefined;
        }
        return `${baseUrl}${url}${query}`;
    }
    createRequest(method, url, config, init) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!init) {
                init = {
                    mode: "cors",
                    redirect: "follow",
                    method: method,
                    body: config === null || config === void 0 ? void 0 : config.body,
                    headers: {},
                };
            }
            if (config.abortToken) {
                init.signal = config.abortToken.getSignal();
            }
            let request = new Request(this.createURL(url, config), init);
            if (init.body) {
                request.headers.set("Content-Type", "application/json;charset=utf-8");
            }
            if (config.withEvents) {
                yield this.em.dispatch(HttpClient.REQUEST_CREATE, request);
            }
            return request;
        });
    }
    static checkResponse(res) {
        if (!res.ok) {
            throw new HttpError(res);
        }
    }
    createResponse(request, config) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(request);
            if (config.withEvents) {
                yield this.em.dispatch(HttpClient.RESPONSE_FETCHED, request);
            }
            HttpClient.checkResponse(response);
            if (config.withEvents) {
                yield this.em.dispatch(HttpClient.RESPONSE_CREATE, request);
            }
            return response.json();
        });
    }
    get(url, params, config = {}, init) {
        return __awaiter(this, void 0, void 0, function* () {
            config = Object.assign(Object.assign(Object.assign({}, defaultConfig), { params }), config);
            const request = yield this.createRequest(HttpMethod.GET, url, config, init);
            return this.createResponse(request, config);
        });
    }
    post(url, body = undefined, config = {}, init) {
        return __awaiter(this, void 0, void 0, function* () {
            config = Object.assign(Object.assign({}, defaultConfig), config);
            if (!config.hasOwnProperty("body") && body) {
                config.body = JSON.stringify(body);
            }
            if (init) {
                init.method = HttpMethod.POST;
                init.body = config.body;
            }
            const request = yield this.createRequest(HttpMethod.POST, url, config, init);
            return this.createResponse(request, config);
        });
    }
    put(url, body = undefined, config = {}, init) {
        return __awaiter(this, void 0, void 0, function* () {
            config = Object.assign(Object.assign({}, defaultConfig), config);
            if (!config.hasOwnProperty("body") && body) {
                config.body = JSON.stringify(body);
            }
            if (init) {
                init.method = HttpMethod.PUT;
                init.body = config.body;
            }
            const request = yield this.createRequest(HttpMethod.PUT, url, config, init);
            return this.createResponse(request, config);
        });
    }
    patch(url, body = undefined, config = {}, init) {
        return __awaiter(this, void 0, void 0, function* () {
            config = Object.assign(Object.assign({}, defaultConfig), config);
            if (!config.hasOwnProperty("body") && body) {
                config.body = JSON.stringify(body);
            }
            const request = yield this.createRequest(HttpMethod.PATCH, url, config, init);
            return this.createResponse(request, config);
        });
    }
    delete(url, body = undefined, config = {}, init) {
        return __awaiter(this, void 0, void 0, function* () {
            config = Object.assign(Object.assign({}, defaultConfig), config);
            if (!config.hasOwnProperty("body") && body) {
                config.body = JSON.stringify(body);
            }
            if (init) {
                init.method = HttpMethod.DELETE;
                init.body = config.body;
            }
            const request = yield this.createRequest(HttpMethod.DELETE, url, config, init);
            return this.createResponse(request, config);
        });
    }
    on(event, callback) {
        this.em.on(event, callback);
    }
}
